<template>
	<div>
		<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
			<div class="card">
				<div class="card-body">
					<div class="row">
						<div class="col-md-6">
							<h5 class="mb-4">
								<strong>Catálogo de tipos de gastos</strong>
							</h5>
						</div>
						<div class="col-md-6 text-right">
							<a-button class="btn btn-info" icon="plus" @click="onAddRecord()" v-if="isUserAdmin">Añadir</a-button>
							<a-button class="btn btn-success ml5" icon="reload" @click="onReload()" />
						</div>
					</div>
					<a-table :columns="columns" :dataSource="expenseTypesList" rowKey="id">
						<span slot="active" slot-scope="record">
							<a-tag color="green" v-if="record.active">Activo</a-tag>
							<a-tag color="red" v-else>Inactivo</a-tag>
						</span>
						<span slot="action" slot-scope="record">
							<a-button type="info" size="small" icon="edit" @click="onEditRecord(record)" />
							<a-button class="ml5" size="small" :icon="record.active ? 'minus-circle' : 'plus-circle'" @click="onToggleRecord(record.id, record.active)" />
						</span>
					</a-table>
				</div>
			</div>
		</a-spin>
		<insertOrUpdateExpenseTypes :visible="modal.visible" :title="modal.title" :payload="modal.payload" @closeModal="onCloseModal" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import _ from 'lodash'
import insertOrUpdateExpenseTypes from '@/components/insertOrUpdateExpenseTypes'

export default {
	name: 'ExpenseTypes',
	components: {
		insertOrUpdateExpenseTypes,
	},
	data() {
		return {
			columns: [
				{
					title: 'ID',
					dataIndex: 'id',
					align: 'center',
				},
				{
					title: 'Nombre',
					dataIndex: 'name',
					align: 'center',
				},
				{
					title: 'Descripción',
					dataIndex: 'description',
				},
				{
					title: 'Estatus',
					scopedSlots: { customRender: 'active' },
					align: 'center',
				},
			],
			modal: {
				visible: false,
				title: '',
				payload: {},
			},
		}
	},
	computed: {
		...mapGetters('user', ['user']),
		...mapGetters('expenseTypes', ['expenseTypesList']),
		spinnerLoaderLabel() {
			return this.$store.state.expenseTypes.spinnerLoaderLabel
		},
		spinnerLoader() {
			return this.$store.state.expenseTypes.spinnerLoader
		},
		isUserAdmin() {
			return this.user.is_admin ? true : false
		},
	},
	beforeMount() {
		if (this.isUserAdmin) {
			this.columns.push({
				title: 'Acciones',
				scopedSlots: { customRender: 'action' },
				align: 'right',
			})
		}
	},
	mounted() {
		if (this.expenseTypesList.length == 0) {
			this.initModule()
		}
	},
	methods: {
		initModule() {
			this.$store.dispatch('expenseTypes/GET')
		},
		onReload() {
			this.initModule()
		},
		onAddRecord() {
			this.modal = {
				visible: true,
				title: 'Añadir registro de tipo de gasto',
				payload: {},
			}
		},
		onEditRecord(record) {
			this.modal = {
				visible: true,
				title: 'Editar registro de tipo de gasto',
				payload: _.cloneDeep(record),
			}
		},
		onToggleRecord(id, status) {
			Swal.fire({
				title: 'Atención',
				text: `¿Desea ${status ? 'deshabilitar' : 'habilitar'} el registro?`,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Sí, continuar',
				cancelButtonText: 'Cancelar',
			}).then((result) => {
				if (result.isConfirmed) {
					if (status) {
						this.$store.dispatch('expenseTypes/DISABLE', id)
					} else {
						this.$store.dispatch('expenseTypes/ENABLE', id)
					}
				}
			})
		},
		onCloseModal() {
			this.modal.visible = false
		},
	},
	watch: {},
}
</script>